module.exports = __webpack_public_path__ + "static/media/scanner.39c41f21.svg";